export interface WsResponse<TData = any, TError = any> {
  data: TData;
  error: TError;
}

export enum WsMessages {}
